import { State } from '../reducers'
import { adapter, paymentMethodsFeatureKey } from './payment-methods.reducer'

export const selectState = (state: State) => state[paymentMethodsFeatureKey]

export const { selectAll: selectAllPaymentMethods, selectEntities: selectPaymentMethodEntities } = adapter.getSelectors(selectState)
